import * as Api from '@ViewModels';
import * as React from 'react';
import { useExportNotesMutation, useExportPostsMutation, useExportTextingReportMutation } from '../../../../../queries';
import { ExportConfirmationModalV2 } from '../../../../../web/components/ExportConfirmation';

export enum ExportDataType {
	Notes,
	Posts,
	Texts,
}

export interface IExportDataButtonProps {
	exportDataType: ExportDataType;
	text: string;
	impersonationContext: Api.IImpersonationContext;
	className?: string;
	disabled?: boolean;
}

export const ExportDataButton: React.FC<IExportDataButtonProps> = props => {
	const onRequestClose = () => {
		exportTextingReportMutation.reset();
		exportNotesMutation.reset();
		exportPostsMutation.reset();
	};

	const exportTextingReportMutation = useExportTextingReportMutation({
		includeAll: true,
		impersonationContext: props.impersonationContext,
	});

	const exportPostsMutation = useExportPostsMutation({
		impersonationContext: props.impersonationContext,
	});

	const exportNotesMutation = useExportNotesMutation({
		impersonationContext: props.impersonationContext,
	});

	const onExportClick = () => {
		switch (props.exportDataType) {
			case ExportDataType.Notes:
				exportNotesMutation.mutate({ exportRequest: {} });
				break;
			case ExportDataType.Texts:
				exportTextingReportMutation.mutate({ filter: {} });
				break;
			case ExportDataType.Posts:
				exportPostsMutation.mutate();
				break;
			default:
				break;
		}
	};

	return (
		<>
			<button className={props.className} onClick={onExportClick} disabled={props.disabled}>
				{props.text}
			</button>

			<ExportConfirmationModalV2
				mutationResult={exportTextingReportMutation}
				modalProps={{
					isOpen: !exportTextingReportMutation.isIdle,
					onRequestClose,
				}}
			/>

			<ExportConfirmationModalV2
				mutationResult={exportNotesMutation}
				modalProps={{
					isOpen: !exportNotesMutation.isIdle,
					onRequestClose,
				}}
			/>

			<ExportConfirmationModalV2
				mutationResult={exportPostsMutation}
				modalProps={{
					isOpen: !exportPostsMutation.isIdle,
					onRequestClose,
				}}
			/>
		</>
	);
};
